// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.

// The header's two actions — the two ways a workspace app comes to be.
export const AppsHubActions = {
  flow: 'x',
  flexWrap: 'wrap',
  gap: 'Y',
  AhBuild: {
    extends: 'AppCapsuleBtnPrimary',
    compact: true,
    text: '{{ workspace.appsHub.buildWithAi | polyglot }}',
    onClick: (e, el) => {
      e.stopPropagation()
      el.call('openAppPage', '/add-app')
    }
  },
  AhStore: {
    extends: 'AppCapsuleBtnGhost',
    compact: true,
    text: '{{ workspace.appsHub.browseStore | polyglot }}',
    onClick: (e, el) => {
      e.stopPropagation()
      // The catalogue's App Store tab (decision 7), in the shell's pane like
      // the navbar's Apps — /apps/store is no app-window route.
      el.call('openAppPage', '/apps/store', { preferSlot: true })
    }
  }
}
